import { enableBodyScroll, disableBodyScroll } from '../common/helpers';

const modalOpenEvent = new CustomEvent('modalopen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalCloseEvent = new CustomEvent('modalclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalAfterOpenEvent = new CustomEvent('modalafteropen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const modalAfterCloseEvent = new CustomEvent('modalafterclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

export function closeModal($modal) {
    if (!$modal) return;

    $modal.dispatchEvent(modalCloseEvent);

    const { modalBtns } = $modal.dataset;

    const $modalToggleBtns = $modal.dataset?.modalToggleBtn ? document.querySelectorAll($modal.dataset.modalToggleBtn) : false;

    enableBodyScroll();

    $modal.classList.remove('modal--active');

    if (modalBtns) {
        const $modalBtns = document.querySelectorAll(modalBtns);

        $modalBtns?.forEach($modalBtn => {
            $modalBtn.setAttribute('aria-expanded', 'false');
        });
    }

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            $modalToggleBtn.classList.remove('modal--active');
            $modalToggleBtn.ariaExpanded = false;
        });
    }

    $modal.dispatchEvent(modalAfterCloseEvent);
}

export function openModal($modal) {
    if (!$modal) return;

    $modal.dispatchEvent(modalOpenEvent);

    const { modalBtns } = $modal.dataset;

    const $modalToggleBtns = $modal.dataset?.modalToggleBtn ? document.querySelectorAll($modal.dataset.modalToggleBtn) : false;

    $modal.style.width = document.body.clientWidth + 'px';

    disableBodyScroll();

    $modal.classList.add('modal--active');

    if (modalBtns) {
        const $modalBtns = document.querySelectorAll(modalBtns);

        $modalBtns?.forEach($modalBtn => {
            $modalBtn.setAttribute('aria-expanded', 'true');
        });
    }

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            $modalToggleBtn.classList.add('modal--active');
            $modalToggleBtn.ariaExpanded = true;
        });
    }

    const $modalFocusEl = $modal.querySelector('a[href], button, input:not([type="hidden"]), textarea, select, details,[tabindex]:not([tabindex="-1"])');

    if ($modalFocusEl) {
        $modalFocusEl.focus();
    }

    const escapeListener = e => {
        if (e.key !== 'Escape') return;

        closeModal($modal);

        document.removeEventListener('keyup', escapeListener);
    };

    document.addEventListener('keyup', escapeListener);

    $modal.dispatchEvent(modalAfterOpenEvent);
};

export function initModals() {
    const $modalToggleBtns = document.querySelectorAll('.modal-open, .modal-close');
    const $modalResize = document.querySelectorAll('.modal, .modal-resize');

    if ($modalToggleBtns.length) {
        $modalToggleBtns.forEach($modalToggleBtn => {
            const $modal = $modalToggleBtn.dataset?.modalTarget ? document.getElementById($modalToggleBtn.dataset.modalTarget) : false;

            if (!$modal) return;

            $modalToggleBtn.addEventListener('click', e => {
                e.preventDefault();
                
                if ($modal.classList.contains('modal--active') && $modalToggleBtn.classList.contains('modal-close')) {
                    closeModal($modal);
                } else if (!$modal.classList.contains('modal--active') && $modalToggleBtn.classList.contains('modal-open')) {
                    openModal($modal);
                }
            });
        });
    }

    if ($modalResize.length) {
        $modalResize.forEach($modal => {
            if ($modal.id && window.location.hash && '#' + $modal.id === window.location.hash) {
                openModal($modal);
            }
        });
    }

    window.addEventListener('resize', () => {
        if (!document.body.classList.contains('no-scroll')) return;

        const $activeModals = document.querySelectorAll('.modal--active');

        enableBodyScroll();

        if ($activeModals) {
            $activeModals.forEach($activeModal => {
                $activeModal.style.width = document.body.clientWidth + 'px';
            });
        }

        disableBodyScroll();
    });
}
